(function() {
    'use strict';

    class FeedbackShareDialogService {
        constructor($mdDialog, $translate){
            this.$mdDialog = $mdDialog;
            this.$translate = $translate;
        }

        feedbackRequstController() {
            this.requestPending = false;
            this.requestSuccess = false;
            this.emailRegex = /^[a-zA-Z0-9.!#$%&’*+\/=?^_`{|}~-]+@[\w-]+(?:\.[\w-]{1,64})+$/;
            this.SOURCE_NAME_MAX_CHAR = 255;
            this.invalidForm = false;
            this.shareModalHeader = this.$translate.instant('icm-web__profile-feedback--send-updates-modal-header',{
                contactName: this.contactName
            });

            this.submitFeedback = function(){
                this.invalidForm = false;
                if (!this.feedbackForm.$valid) {
                    this.invalidForm = true;
                    this.errorMessage = this.$translate.instant('icm-web__profile-feedback--update-error-message');
                } else if (this.feedbackForm.$dirty && (this.sourceName || this.email || this.feedbackDescription)) {
                    let payload = this.getContactPayload();
                    this.requestPending = true;
                    this.requestRejected = false;
                    this.InfluencerContactService.submitFeedback(payload).then(function onSuccess() {
                        this.requestPending = false;
                        this.requestSuccess = true;
                    }.bind(this)).catch(function onError() {
                        this.errorMessage = this.$translate.instant('icm-web__profile-feedback--update-error-message');
                        this.requestPending = false;
                        this.requestRejected = true;
                    }.bind(this)).finally(function afterAll() {
                        this.trackContactFeedbackCompleted();
                    }.bind(this));
                }
            };

            this.getContactPayload = function getContactPayload() {
                let payload = {
                    update_request: {
                        type: 'incorrect',
                        // contact being updated
                        resource_uuid: this.contact.id,
                        // company doing the update
                        company_name: this.currentCompany.name,
                        company_id: this.currentCompany._id,
                        account_id: this.currentCompany.accountId,
                        opportunity_id: this.currentCompany.opportunityId,
                        // user doing the update
                        customer_email: this.currentUser.email,
                        user_id: this.currentUser._id,
                        language: this.currentUser.language
                    }
                };

                if(this.email){
                    payload.update_request.new_resource_email = this.email;
                }
                if(this.sourceName){
                    payload.update_request.new_resource_source_name = this.sourceName;
                }
                if(this.feedbackDescription){
                    payload.update_request.description = this.feedbackDescription;
                }
                return payload;
            };

            this.trackContactFeedbackCompleted = function trackContactFeedbackCompleted() {
                var data = {
                        source: 'webapp',
                        label: 'icm_contact_feedback_completed',
                        emailRegex: this.emailRegex,
                        contactId: this.contact.id,
                        userId: this.currentUser.email + ' (' + this.currentUser._id + ') ' + this.currentCompany.name
                    },
                    feedbackData = {
                        type: 'incorrect',
                        description: this.feedbackDescription || 'No description'
                    };
                this.AnalyticsService.trackFeedbackLoop('completed', data, feedbackData);
            }.bind(this);
        }

        showShareDialog(vars){
            this.$mdDialog.show(
                this.$mdDialog.mwMiniModal({
                    locals: vars,
                    controller: this.feedbackRequstController,
                    templateUrl: 'icm-web/views/feedback_share_modal',
                    controllerAs: '$ctrl'
                })
            );
        }
    }

    angular.module('MW.Influencers.FeedbackShareDialogService', [
        'ngMaterial',
        'ngMessages',
        'mwAppComponents'
    ])
        .service('FeedbackShareDialogService', [
            '$mdDialog',
            '$translate',
            FeedbackShareDialogService]);
})();